import {
  CountryConfig,
  DetectionSource,
  ISO_TO_COUNTRY,
  COUNTRY_CONFIGS,
} from '../config/countryConfig';
import TIMEZONE_TO_ISO from '../config/timezoneToCountry.json';

interface CountryResolution {
  country: string;
  isoCode: string;
  countryConfiguration: CountryConfig | null;
  detectionSource: DetectionSource;
}

const DEFAULT_ISO = 'IN';

function detectFromTimezone(): string | null {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const iso = (TIMEZONE_TO_ISO as Record<string, string>)[tz];
    return iso && ISO_TO_COUNTRY[iso] ? iso : null;
  } catch {
    return null;
  }
}

function buildResolution(isoCode: string, source: DetectionSource): CountryResolution {
  const resolvedIso = ISO_TO_COUNTRY[isoCode] ? isoCode : DEFAULT_ISO;
  const fullName = ISO_TO_COUNTRY[resolvedIso];
  const config = COUNTRY_CONFIGS[resolvedIso] ?? COUNTRY_CONFIGS['DEFAULT'];
  return {
    country: fullName,
    isoCode: resolvedIso,
    countryConfiguration: { countryCode: resolvedIso, ...config },
    detectionSource: source,
  };
}

export function useCountryConfiguration(): CountryResolution {
  const iso = detectFromTimezone();
  return buildResolution(iso ?? DEFAULT_ISO, iso ? 'timezone' : 'default');
}
